export const formatResultNumber = (num) => {
  return num
    .toLocaleString('fi-FI', {
      style: 'decimal',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    })
};